import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function KnowledgeBase() {
  const navigate = useNavigate()
  useEffect(() => { navigate('/sesiones', { replace: true }) }, [navigate])
  return null
}
